namespace TotalContest {
    import Component = TotalCore.Common.Component;

    @Component('components.totalcontest', {
        templateUrl: 'menu-component-template',
        bindings: {

        }
    })
    class MenuComponent {

        public steps = [
            {
                title: 'Welcome',
                description: 'A brief introduction.'
            },
            {
                title: 'Get Started',
                description: 'Some resources to start with.'
            },
            {
                title: 'Let\'s be friends',
                description: 'Because we care about you.'
            },
            {
                title: 'One last thing',
                description: 'Your help will make difference.'
            },
        ];

        public constructor(private $scope, public OnboardingService) {
        }
    }
}
